export function normalizeCssDimension(value: string | undefined): string | undefined {
    if (!value) return value;

    if (/^\d+$/.test(value.trim())) {
        return `${value}px`;
    }

    return value;
}

export function extractDimensionsFromStyle(style: string): { width?: string; height?: string } {
    if (!style) return {};
    
    const dimensions: { width?: string; height?: string } = {};
    
    const widthMatch = style.match(/width\s*:\s*([^;]+)/i);
    if (widthMatch) {
        dimensions.width = widthMatch[1].trim();
    }
    
    const heightMatch = style.match(/height\s*:\s*([^;]+)/i);
    if (heightMatch) {
        dimensions.height = heightMatch[1].trim();
    }
    
    return dimensions;
}
